import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Address } from '../models/user-profile.model';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AddressService } from '../services/address.service';

import { NotificationService } from '../../../shared/services/notification.service';
@Component({
  selector: 'app-profile-direcciones',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './profile-direcciones.component.html',
  styleUrls: ['./profile-direcciones.component.scss']
})
export class ProfileDireccionesComponent implements OnInit {
  private router = inject(Router);
  direcciones: Address[] = [];
  private readonly baseUrl = environment.apiBaseUrl;
  private http = inject(HttpClient);
  private addressService = inject(AddressService);

  private notificationService = inject(NotificationService);

  editingId: string | null = null;             
  editedDireccion: Address | null = null; 

  ngOnInit() {
    this.loadDirecciones();
    
  }

  loadDirecciones() {
    const profileData = localStorage.getItem('profileData');
    if (profileData) {
      const data = JSON.parse(profileData);
      this.direcciones = data.address || [];
    }
  }

  onAddDireccion() {
    this.router.navigate(['/add-direccion']);
  }

  

  onDelete(direccion: Address) {
    this.notificationService.showConfirm(
      '¿Estás seguro de que deseas eliminar esta dirección?',
      'Confirmar eliminación'
    ).subscribe(result => {
      if (result) {
        this.eliminarDireccion(direccion);
      }
    });
  }

  eliminarDireccion(direccion: Address) {
    const token = localStorage.getItem('accessToken') || '';
    const cognitoId = localStorage.getItem('cognito') || '';
    const url = `${this.baseUrl}/address/${cognitoId}/delete`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });

    const body = {
      identifier: {
        tenants: "adff7f6a-e97d-11eb-9a03-0242ac130003",
        app: "PortalAsistencia"
      },
      petition: {
        idAddress: direccion.idAddress
      }
    };

    this.http.request('delete', url, { body, headers }).subscribe({
      next: (response) => {
        this.direcciones = this.direcciones.filter(d => d.idAddress !== direccion.idAddress);

        const profileData = localStorage.getItem('profileData');
        if (profileData) {
          const data = JSON.parse(profileData);
          data.address = this.direcciones;
          localStorage.setItem('profileData', JSON.stringify(data));
        }

        this.notificationService.showSuccess('Dirección eliminada correctamente.');
      },
      error: (error) => {
        console.error('Error eliminando dirección:', error);
        this.notificationService.showError('Error eliminando dirección. Intenta de nuevo.');
      }
    });
  }



 onEdit(direccion: any) {
  sessionStorage.setItem('direccionParaEditar', JSON.stringify(direccion));
  this.router.navigate(['/update-direccion']);
}


  onGoBack() {
    this.router.navigate(['/headerprofile']);
  }
}
